document.addEventListener("DOMContentLoaded", () => {
  initExclusiveDeals();
  initCartObserver();
  syncExclusiveButtons();

  /* ---- Arrow toggle ---- */
  const toggleBtns = document.querySelectorAll('[data-exclusive-toggle]');
  
  toggleBtns.forEach((btn) => {
    btn.addEventListener('click', function () {
      const btnParent = btn.closest('.scd__exclusive-product-card');
      const expanded = btnParent.querySelector('[data-exclusive-expanded]');
      const isOpen = expanded.classList.contains('open');
      expanded.classList.toggle('open', !isOpen);
  
      // FIX: use btn, not NodeList
      btn.classList.toggle('open', !isOpen);
      btn.setAttribute('aria-expanded', String(!isOpen));
    });
  });
  (function() {
    const originalFetch = window.fetch;

    window.fetch = async (...args) => {
      const response = await originalFetch(...args);

      const url = args[0]?.toString() || "";

      if (
        url.includes("/cart/add") ||
        url.includes("/cart/change") ||
        url.includes("/cart/update") ||
        url.includes("/cart/clear")
      ) {
        setTimeout(() => {
          syncExclusiveButtons();
        }, 300);
      }

      return response;
    };
  })();
  
});

// async function syncExclusiveButtons() {
//   const cart = await fetch('/cart.js').then(r => r.json());

//   const variantIdsInCart = cart.items.map(item =>String(item.variant_id));

//   document
//     .querySelectorAll('[data-exclusive-atc]')
//     .forEach(btn => {

//       const variantId = btn.dataset.variantId;
//       const textEl = btn.querySelector('[data-exclusive-btn-text]');

//       const inCart = variantIdsInCart.includes(variantId);

//       btn.dataset.inCart = inCart;

//       // if (textEl) {
//       //   textEl.textContent = inCart
//       //     ? 'Remove From Cart'
//       //     : 'Add To Cart';
//       // }
//     });
    
//     document.querySelectorAll('.scd__exclusive-product-card').forEach(card => {
//       const btn = card.querySelector('[data-exclusive-atc]');
//       if (btn?.dataset.inCart === "true") {
//         card.style.display = "none";
//       }
//     });
// }

async function syncExclusiveButtons() {
  const cart = await fetch('/cart.js').then(r => r.json());
  console.log(cart,"cart---");
  const variantIdsInCart = cart.items.map(i => String(i.variant_id));

  document.querySelectorAll('[data-exclusive-atc]').forEach(btn => {
    const variantId = btn.dataset.variantId;
    const inCart = variantIdsInCart.includes(variantId);

    btn.dataset.inCart = inCart;
  });

  const cards = document.querySelectorAll('.scd__exclusive-product-card');
  cards.forEach(card => {
    const btn = card.querySelector('[data-exclusive-atc]');
    if (!btn) return;

    const shouldHide = btn.dataset.inCart === "true";

    card.style.display = shouldHide ? "none" : "block";

  });

  const hideExclusive = document.querySelector('.scd__exclusive-deals');
  // console.log(hideExclusive,"hideExclusive---");

  const allCardsHidden = [...cards].every(
    card => card.style.display === 'none'
  );
//   console.log(allCardsHidden,"allCardsHidden---");

  if (allCardsHidden) {
    if(hideExclusive != null ){
      hideExclusive.style.display = 'none';
    }
  } else {
    if(hideExclusive != null ){
      hideExclusive.style.display = 'flex';
    }
  }
}
/**
 * =========================
 * INIT BUTTONS
 * =========================
 */
function initExclusiveDeals() {
  document.querySelectorAll("[data-exclusive-atc]").forEach((btn) => {
    btn.onclick = handleExclusiveClick;
  });
}

/**
 * =========================
 * HANDLE ADD / REMOVE
 * =========================
 */
async function handleExclusiveClick(e) {
  const btn = e.currentTarget;
  const variantId = btn.dataset.variantId;

  btn.disabled = true;

  const inCart = btn.dataset.inCart === "true";

  if (inCart) {
    await removeItem(variantId,btn);
  } else {
    await addItem(variantId,btn);
  }

  // await syncCart(); // 🔥 IMPORTANT FIX
  // document.querySelector("m-cart-drawer")?.onCartDrawerUpdate();
  // setTimeout(() => {
  //   syncExclusiveButtons();
  // }, 300);
}


function openCartDrawerAfterUpdate() {
  const drawer = document.querySelector('m-cart-drawer');
  if (!drawer) return;

  drawer.onCartDrawerUpdate();
  drawer.open?.();
}

// function refreshCartSections() {
//   fetch('/?sections=cart-drawer')
//     .then(res => res.json())
//     .then(data => {
//       const html = new DOMParser()
//         .parseFromString(data['cart-drawer'], 'text/html');

//       const newDrawer = html.querySelector('m-cart-drawer');
//       const oldDrawer = document.querySelector('m-cart-drawer');

//       if (newDrawer && oldDrawer) {
//         oldDrawer.innerHTML = newDrawer.innerHTML;
//       }
//     });
// }

/**
 * =========================
 * ADD ITEM
 * =========================
 */
async function addItem(variantId,btn) {
  console.log('added---click');
  let btnText = btn.querySelector('[data-exclusive-btn-text]');
  return fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id: variantId,
      quantity: 1,
    }),
  })
  .then(res => res.json())
  .then(() => {

    // alert('added---');
    btn.setAttribute('data-in-cart',"true");
    // btnText.textContent = 'Remove From Cart';
    // openCartDrawerAfterUpdate();
    syncExclusiveButtons().then(() => {
      btn.disabled = false;
      document.querySelector("m-cart-drawer")?.onCartDrawerUpdate();
    });
  });
}

/**
 * =========================
 * REMOVE ITEM (FIXED)
 * =========================
 */

async function removeItem(variantId,btn) {
  let btnTextAdd = btn.querySelector('[data-exclusive-btn-text]');

  const cart = await fetch("/cart.js").then((r) => r.json());
  const item = cart.items.find((i) => i.variant_id == variantId);

  if (!item) return;

  return fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id: item.key,
      quantity: 0,
    }),
  })
  .then(res => res.json())
  .then(() => {
    // 🔥 refresh cart UI
    // alert('removed---');
    btn.setAttribute('data-in-cart',"false");
    // btnTextAdd.textContent = 'Add to Cart';
    // openCartDrawerAfterUpdate();
    syncExclusiveButtons().then(() => {
      btn.disabled = false;
      document.querySelector("m-cart-drawer")?.onCartDrawerUpdate();
    });
  });
}

/**
 * =========================
 * 🔥 FULL CART SYNC (IMPORTANT PART)
 * =========================
 */
// async function syncCart() {
//   // 1. get fresh section HTML
//   const res = await fetch("/?section_id=cart-drawer-new");
//   const html = await res.text();

//   const parser = new DOMParser();
//   const doc = parser.parseFromString(html, "text/html");

//   const newDrawer = doc.querySelector(".scd__wrapper");
//   const oldDrawer = document.querySelector(".scd__wrapper");

//   if (newDrawer && oldDrawer) {
//     oldDrawer.innerHTML = newDrawer.innerHTML;
//   }

//   // 2. rebind everything
//   initExclusiveDeals();
//   updateHeaderCount();
// }

async function syncCart() {
  const res = await fetch("/?section_id=cart-drawer-new");
  const html = await res.text();

  const doc = new DOMParser().parseFromString(html, "text/html");

  const newWrapper = doc.querySelector(".scd__wrapper");
  const oldWrapper = document.querySelector(".scd__wrapper");

  if (!newWrapper || !oldWrapper) return;

  // Replace only inner cart content, NOT full wrapper events layer
  const newContent = newWrapper.querySelector(".scd__content");
  const oldContent = oldWrapper.querySelector(".scd__content");

  if (newContent && oldContent) {
    oldContent.innerHTML = newContent.innerHTML;
  }

  initExclusiveDeals();
  updateHeaderCount();
}

/**
 * =========================
 * HEADER COUNT FIX
 * =========================
 */
// function updateHeaderCount() {
//   fetch("/cart.js")
//     .then((r) => r.json())
//     .then((cart) => {
//       const header = document.querySelector(".m-cart-drawer--header h3");

//       if (header) {
//         const count = cart.item_count;
//         header.innerText =
//           count > 1
//             ? `Your Cart (${count} items)`
//             : `Your Cart (${count} item)`;
//       }

//       // footer total fix
//       const totalEls = document.querySelectorAll(
//         "[data-checkout-total], .scd__subtotal-price"
//       );

//       totalEls.forEach((el) => {
//         el.innerText = Shopify.formatMoney
//           ? Shopify.formatMoney(cart.total_price)
//           : cart.total_price;
//       });
//     });
// }
function updateHeaderCount() {
  fetch("/cart.js")
    .then((r) => r.json())
    .then((cart) => {

      const countText = cart.item_count > 1
        ? `Your Cart (${cart.item_count} items)`
        : `Your Cart (${cart.item_count} item)`;

      const header = document.querySelector(".m-cart-drawer--header h3");
      if (header) header.innerText = countText;

      // FIX: always format manually in cents-safe way
      const money = new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR"
      }).format(cart.total_price / 100);

      document.querySelectorAll("[data-checkout-total]").forEach(el => {
        el.textContent = money;
      });
    });
}
/**
 * =========================
 * OBSERVER (optional safety)
 * =========================
 */
function initCartObserver() {
  const target = document.querySelector(".scd__wrapper");

  if (!target) return;

  const observer = new MutationObserver(() => {
    initExclusiveDeals();
  });

  observer.observe(target, {
    childList: true,
    subtree: true,
  });
}